import {useQuery} from "@tanstack/react-query"
import axios from "axios"
import {FieldListSearchResult} from "../types/FieldList";

interface UseFieldListsListQueryProps {
    page: number
    perPage: number
}
export default function useFieldListsListQuery({
    page,
    perPage,
}: UseFieldListsListQueryProps) {
    return useQuery({
        queryKey: ['fieldLists', page, perPage],
        queryFn: async () => {
            const GET_FIELD_LISTS_ENDPOINT = '/admin/action/automation/admin/getAllFieldListByPagination';
            const { data } = await axios.get(GET_FIELD_LISTS_ENDPOINT, {
                params: {
                    page: page,
                    count: perPage,
                }
            })
            return {
                nodes: data.FIELD_LIST.results.map((el : any) => {
                    return el;
                }) as Array<FieldListSearchResult>,
                totalCount: data.FIELD_LIST.totalCount,
            }
        },
    })
}